var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('ClassMenu',{directives:[{name:"show",rawName:"v-show",value:(_vm.menuShowFlag),expression:"menuShowFlag"}]}),_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(!_vm.menuShowFlag),expression:"!menuShowFlag"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }